export const ratingData = {
  scoring: '9.4', // https://metabase.tilli.fr/question/1295
  numberOfReviews: '16866', // https://metabase.tilli.fr/question/1294
  numberOfTillistes: 850,
  numberOfItems: 181000,
};
